export default __webpack_public_path__ + "static/media/PNG-AVAX.015aa8b7.png";